import utahHeaderLoaded from './utahHeaderLoaded';
import { useEffect, useState } from 'react';

const GLOBAL_KEY = '@utahdts/utah-design-system-header';
// The Utah Design System header UMD bundle is served from ui/public at site root.
const UTAH_HEADER_UMD_URL = '/utah-design-system-header.umd.js';

const loadedLibrary = () => {
  const lib = window[GLOBAL_KEY];
  return lib && typeof lib.setUtahHeaderSettings === 'function' ? lib : null;
};

// only the first call should inject the script, the rest reuse the loaded library
let isUtahHeaderRequested = false;

/**
 * call in render of a functional component to get a state change when the Utah
 * Design System header library has loaded
 *
 * @param utahHeaderUrl optional override for the UMD bundle URL
 * @return window['@utahdts/utah-design-system-header'] or null until it is loaded
 */
export default ({ utahHeaderUrl } = {}) => {
  const [utahHeader, setUtahHeader] = useState(loadedLibrary);

  // inject the UMD bundle once - put in useEffect so it's not in the render
  useEffect(() => {
    if (!isUtahHeaderRequested && !window[GLOBAL_KEY]) {
      isUtahHeaderRequested = true;
      const script = document.createElement('script');
      script.setAttribute('src', utahHeaderUrl || UTAH_HEADER_UMD_URL);
      document.head.appendChild(script);
    }
  }, [utahHeaderUrl]);

  useEffect(() => {
    let mounted = true;
    utahHeaderLoaded.then((lib) => {
      if (mounted) {
        setUtahHeader(lib);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return utahHeader;
};
